import { getDirectionVectorForRailingInclinedParts } from './get-direction-vector-for-railing-inclined-parts';

declare const THREE: any;

/**
 *@description
 * Mostly used to align
 * infills or railing parts
 * in z-x-direction based
 * on vector from two
 * positions (pos1, pos2)
 * @param {any} pos1
 * @param {any} pos2
 * @returns {any}
 * @function
 */
export const alignObjectBetweenTwoPosts = (object, pos1, pos2): void => {
  let direction = getDirectionVectorForRailingInclinedParts(pos1, pos2);
  const atempts = 5;
  for (let atempt = 0; atempt < atempts; atempt++) {
    const worldDir = object.getWorldDirection(new THREE.Vector3());

    if (
      !(
        direction.x - worldDir.x > -0.05 &&
        direction.x - worldDir.x < 0.05 &&
        direction.z - worldDir.z > -0.05 &&
        direction.z - worldDir.z < 0.05
      )
    ) {
      object.rotation.y += worldDir.angleTo(direction);
    }
  }
};



// WEBPACK FOOTER //
// ./src/app/services/railing/utils/align-object-between-two-posts.ts